/* eslint-disable no-unused-vars */
import db from "../db/db";
import { AgentUtils } from "./AgentUtils";
import axios from "axios";
import { PricingUtils } from "./PricingUtils";
import API from "./API";
import { EscPos } from "salolabs-escpos-xml";
import { Store } from "./Store";
import { Buffer } from "buffer";

export const PrintUtils = {
  printReceipt,
  //printFile,
  //rePrint,
  augmentSaleDetailsForPrint,
  generateReceiptAsPdf,
  getCloudPrintToken,
  openDrawer,
  rePrint,
  printBarcode,
};

async function printBarcode(
  printerType,
  configKey,
  printData,
  translate,
  confirmPrint,
  setAlert
) {
  let printerId = "";
  if (localStorage.getItem("w_barcode_Printing_mode")) {
    if (printerType === "barcodePrinter") {
      if (!localStorage.getItem("w_barcodePrinter")) {
        setAlert({
          show: true,
          title: translate("Failure"),
          message: translate("Not able to find barcode printer setting"),
          type: "success",
        });
        return;
      } else {
        let json = JSON.parse(localStorage.getItem("w_barcodePrinter"));
        printerId = json.value;
      }
    }
    if (printerType === "shelfLabelPrinter") {
      if (!localStorage.getItem("w_shelfLabelPrinter")) {
        setAlert({
          show: true,
          title: translate("Failure"),
          message: translate("Not able to find shelf label printer setting"),
          type: "success",
        });
        return;
      } else {
        let json = JSON.parse(localStorage.getItem("w_shelfLabelPrinter"));
        printerId = json.value;
      }
    }

    let dbData = await db.config.where("name").equals(configKey).toArray();
    let configText = dbData[0].configTxt;
    let base64String = prepareBarcodePrint(printData, configText);

    let printingMode = JSON.parse(
      localStorage.getItem("w_barcode_Printing_mode")
    );
    if (printingMode.value === "LOCAL") {
      printBarcodeViaLocalPrint(
        printerId,
        base64String,
        translate,
        confirmPrint,
        setAlert
      );
    } else if (printingMode.value === "CLOUD_PRINT") {
      //printBarcodeViaCloudPrint();
    } else {
      setAlert({
        show: true,
        title: translate("Failure"),
        message: translate("Not able to find barcode print settings"),
        type: "success",
      });
    }
  } else {
    setAlert({
      show: true,
      title: translate("Failure"),
      message: translate("Not able to find barcode print settings"),
      type: "success",
    });
  }
}

async function printBarcodeViaLocalPrint(
  printerId,
  base64String,
  translate,
  confirmPrint,
  setAlert
) {
  let payload = {};
  payload["data"] = base64String;
  let status = await sendPrintCommandToLocalAgent(printerId, payload);
  console.log("####", status);
  if (!status || "SUCCESS" != status.data) {
    setAlert({
      show: true,
      title: translate("Error!"),
      message: translate(
        "Error While printing, check Printer configured correctly"
      ),
    });
  }
}

function prepareBarcodePrint(printData, configText) {
  let finalPrint = configText;
  finalPrint = finalPrint.replaceAll("{BARCODE}", printData.barcode);
  finalPrint = finalPrint.replaceAll("{STORE_NAME}", printData.storeName);
  finalPrint = finalPrint.replaceAll("{TELEPHONE}", printData.contactNumber);
  finalPrint = finalPrint.replaceAll("{ITEM_NAME}", printData.itemName);
  finalPrint = finalPrint.replaceAll("{ITEM_NAME_SHORT}", printData.shortName);
  finalPrint = finalPrint.replaceAll(
    "{NUMBER_ITEM_PRICE}",
    parseInt(printData.itemPrice)
  );
  finalPrint = finalPrint.replaceAll(
    "{DECIMAL_ITEM_PRICE}",
    printData.itemPrice
  );
  finalPrint = finalPrint.replaceAll(
    "{NUMBER_ITEM_PRICE_AFTER_TAX}",
    parseInt(printData.itemPrice)
  );
  finalPrint = finalPrint.replaceAll(
    "{DECIMAL_ITEM_PRICE_AFTER_TAX}",
    printData.itemPrice
  );

  finalPrint = finalPrint.replaceAll(
    "{NUMBER_ITEM_PRICE_RSP}",
    parseInt(printData.priceRsp)
  );
  finalPrint = finalPrint.replaceAll(
    "{DECIMAL_ITEM_PRICE_RSP}",
    printData.priceRsp
  );

  finalPrint = finalPrint.replaceAll(
    "{NUMBER_ITEM_PRICE_RSP}",
    parseInt(printData.priceRsp)
  );
  finalPrint = finalPrint.replaceAll(
    "{DECIMAL_ITEM_PRICE_RSP}",
    printData.priceRsp
  );

  finalPrint = finalPrint.replaceAll(
    "{NUMBER_PRICE_EX_PROMO_EX_TAX}",
    parseInt(printData.priceExPromotionExTax)
  );
  finalPrint = finalPrint.replaceAll(
    "{DECIMAL_PRICE_EX_PROMO_EX_TAX}",
    printData.priceExPromotionExTax
  );

  finalPrint = finalPrint.replaceAll(
    "{NUMBER_PROMOTION_AMOUNT}",
    parseInt(printData.promotionAmount)
  );
  finalPrint = finalPrint.replaceAll(
    "{DECIMAL_PROMOTION_AMOUNT}",
    printData.promotionAmount
  );

  finalPrint = finalPrint.replaceAll(
    "{NUMBER_TAX_AMOUNT}",
    parseInt(printData.taxAmount)
  );
  finalPrint = finalPrint.replaceAll(
    "{DECIMAL_TAX_AMOUNT}",
    printData.taxAmount
  );
  finalPrint = finalPrint.replaceAll(
    "{productInfoField1}",
    printData.productInfoField1
  );
  finalPrint = finalPrint.replaceAll(
    "{productInfoField2}",
    printData.productInfoField2
  );
  finalPrint = finalPrint.replaceAll(
    "{productInfoField3}",
    printData.productInfoField3
  );
  finalPrint = finalPrint.replaceAll(
    "{productInfoField4}",
    printData.productInfoField4
  );
  finalPrint = finalPrint.replaceAll(
    "{productInfoField5}",
    printData.productInfoField5
  );
  finalPrint = finalPrint.replaceAll(
    "{productInfoField6}",
    printData.productInfoField6
  );

  finalPrint = finalPrint.replaceAll("{LABEL_QUANTITY}", printData.qty);

  console.log(finalPrint);

  var base64String = Buffer.from(finalPrint).toString("base64");

  return base64String;
}

function augmentSaleDetailsForPrint(payload, decimal, saleType) {
  payload.cashPayment = "";
  payload.cardPayment = "";
  payload.creditPayment = "";
  payload.downPayment = "";
  payload.bankOnlinePayment = "";
  let credit = 0;
  let advanceAmount = 0;

  if (payload.salePaymentBeanList) {
    for (let payment of payload.salePaymentBeanList) {
      if (payment.payCode === "CASH") {
        payload.cashPayment = PricingUtils.formattedNumber(
          payment.amount,
          decimal
        );
        if (saleType === "SALE_ORDER" || saleType === "SERVICE") {
          advanceAmount = advanceAmount + parseFloat(payment.amount);
        }
      }
      if (payment.payCode === "CARD") {
        payload.cardPayment = PricingUtils.formattedNumber(
          payment.amount,
          decimal
        );
        if (saleType === "SALE_ORDER" || saleType === "SERVICE") {
          advanceAmount = advanceAmount + parseFloat(payment.amount);
        }
      }
      if (payment.payCode === "BANKONLINE") {
        payload.bankOnlinePayment = PricingUtils.formattedNumber(
          payment.amount,
          decimal
        );
        if (saleType === "SALE_ORDER" || saleType === "SERVICE") {
          advanceAmount = advanceAmount + parseFloat(payment.amount);
        }
      }
      if (payment.payCode === "CREDIT") {
        payload.creditPayment = PricingUtils.formattedNumber(
          payment.amount,
          decimal
        );
        credit = parseFloat(payment.amount);
      }
      if (payment.payCode === "ADVANCE") {
        advanceAmount = parseFloat(payment.amount);
      }
    }
  }
  payload.downPayment = PricingUtils.formattedNumber(
    parseFloat(payload.totalAmount) - credit,
    decimal
  );

  if (advanceAmount > 0) {
    payload.advanceAmount = PricingUtils.formattedNumber(
      advanceAmount,
      decimal
    );
  }
}

async function generateReceiptAsPdf(configKey, printData, buttonIndex) {
  configKey = buttonIndex && buttonIndex == 1 ? configKey + "_2" : configKey;
  console.log("generateReceiptAsPdf configKey", configKey);
  let payload = await preparePayload(configKey, printData, buttonIndex);
  payload["pdfFlag"] = true;
  let api = (await AgentUtils.getBaseUrl()) + "/api/v1/agent/printjasper";
  let { data } = await API.post(api, payload);
  return data;
}

async function printReceipt(
  terminalBean,
  configKey,
  printData,
  setAlert,
  enableReprint,
  translate,
  confirmPrint,
  withOpenDrawer,
  openDrawer,
  pdfViewer,
  buttonIndex
) {
  console.log("PRINT", terminalBean);
  configKey = buttonIndex && buttonIndex == 1 ? configKey + "_2" : configKey;
  console.log("configKey", configKey);
  if (terminalBean.printingMode === "CLOUD_PRINT") {
    console.log("buttonIndex", buttonIndex);
    await cloudPrint(
      buttonIndex == 1
        ? terminalBean.receiptPrinterTwo
        : terminalBean.receiptPrinter,
      // terminalBean.receiptPrinter,
      configKey,
      printData,
      setAlert,
      enableReprint,
      translate,
      confirmPrint,
      withOpenDrawer,
      terminalBean
    );
  } else if (terminalBean.printingMode === "BLUETOOTH") {
    await blueTothPrint(
      configKey,
      printData,
      setAlert,
      enableReprint,
      translate,
      confirmPrint,
      withOpenDrawer,
      terminalBean
    );
  } else if (terminalBean.printingMode === "LOCAL") {
    await localPrint(
      buttonIndex == 1
        ? terminalBean.receiptPrinterTwo
        : terminalBean.receiptPrinter,
      configKey,
      printData,
      setAlert,
      enableReprint,
      translate,
      confirmPrint,
      withOpenDrawer,
      terminalBean
    );
  } else {
    await showPrintInPopup(
      terminalBean,
      configKey,
      printData,
      setAlert,
      enableReprint,
      translate,
      confirmPrint,
      withOpenDrawer,
      openDrawer,
      pdfViewer,
      buttonIndex
    );
  }
}

async function showPrintInPopup(
  terminalBean,
  configKey,
  printData,
  setAlert,
  enableReprint,
  translate,
  confirmPrint,
  withOpenDrawer,
  openDrawer,
  pdfViewer
) {
  let payload = await preparePayload(
    configKey,
    printData,
    null,
    null,
    terminalBean
  );
  payload["pdfFlag"] = true;

  try {
    let response = await sendPrintRequestToPosServer(payload);

    if (enableReprint) {
      let save = {};
      save.data = payload;
      save.mode = "PDF";
      localStorage.setItem("w_lastPrint", JSON.stringify(save));
    }

    pdfViewer(response);
  } catch (e) {
    console.log(e);
    setAlert({
      show: true,
      title: translate("Error!"),
      message: translate(
        "Error While generating report, Please contact Support"
      ),
    });
  }
}

async function blueTothPrint(
  configKey,
  printData,
  setAlert,
  enableReprint,
  translate,
  confirmPrint,
  withOpenDrawer,
  terminalBean
) {
  let payload = await preparePayload(
    configKey,
    printData,
    "BT",
    null,
    terminalBean
  );
  try {
    if (AgentUtils.isAndroid()) {
      let response = window.JSBridge.print("BT", payload.data);
      if (response === "OK") {
        console.log("OK response");
        if (confirmPrint) {
          setAlert({
            show: true,
            title: translate("Success"),
            message: translate("Print Successful"),
            type: "success",
          });
        }
      } else {
        if (setAlert) {
          setAlert({
            show: true,
            title: translate("Error!"),
            message: translate(
              "Error While Printing, check Bluetooth Printer is connected"
            ),
          });
        }
      }
    } else {
      setAlert({
        show: true,
        title: translate("Error!"),
        message: translate(
          "Can not use Bluetooth Printer Here , Please use Android App or Cloud Printer"
        ),
      });
    }
  } catch (err) {
    console.log(err);
    if (setAlert) {
      setAlert({
        show: true,
        title: translate("Error!"),
        message: translate(
          "Error While Printing, check Bluetooth Printer is connected and Paired"
        ),
      });
    }
  }
}

async function cloudPrint(
  printerId,
  configKey,
  printData,
  setAlert,
  enableReprint,
  translate,
  confirmPrint,
  withOpenDrawer,
  terminalBean
) {
  let url = "";
  let apiKey = "";
  let token = "";

  for (let i = 0; i < 3; i++) {
    try {
      if (localStorage.getItem("w_cloud_print_token")) {
        token = localStorage.getItem("w_cloud_print_token");
        url = localStorage.getItem("w_cloud_print_url");
      } else {
        [url, token] = await getCloudPrintToken();
        localStorage.setItem("w_cloud_print_token", token);
      }

      let payload = await preparePayload(
        configKey,
        printData,
        printerId,
        withOpenDrawer,
        terminalBean
      );

      try {
        await sendPrintRequestToServer(url, token, payload, printerId);
      } catch (e) {
        //if Expired
        [url, token] = await getCloudPrintToken(url, apiKey);
        localStorage.setItem("w_cloud_print_token", token);
        await sendPrintRequestToServer(url, token, payload, printerId);
      }
      if (enableReprint) {
        let save = {};
        save.data = payload;
        save.printer = printerId;
        save.mode = "CLOUD_PRINT";
        localStorage.setItem("w_lastPrint", JSON.stringify(save));
      }
      if (confirmPrint) {
        setAlert({
          show: true,
          title: translate("Success"),
          message: translate("Print Successful"),
          type: "success",
        });
      }
      break;
    } catch (err) {
      console.log("Error while Printing Will Retry", err);
      if (i >= 2) {
        if (setAlert) {
          setAlert({
            show: true,
            title: translate("Error!"),
            message: translate(
              'Error While Printing, Check agent is running and "Receipt" printer connected'
            ),
          });
        }
      }
    }
  }
}

async function localPrint(
  printerId,
  configKey,
  printData,
  setAlert,
  enableReprint,
  translate,
  confirmPrint,
  withOpenDrawer,
  terminalBean
) {
  let url = "";
  let apiKey = "";
  let token = "";

  for (let i = 0; i < 3; i++) {
    try {
      let dbData = await db.setting
        .where("sKey")
        .equals("manual_setting")
        .toArray();

      let payload = await preparePayload(
        configKey,
        printData,
        printerId,
        withOpenDrawer,
        terminalBean
      );
      let serverSidePrinting = false;
      if (dbData && dbData.length > 0) {
        let settingBean = JSON.parse(dbData[0].sValue);
        if (settingBean && settingBean.serverSidePrinting) {
          serverSidePrinting = true;
        } else if (settingBean && settingBean.serverSideRendereing) {
          let d = { ...printData };
          let pdfData = await generateReceiptAsPdf(configKey, d);
          payload.pdfData = pdfData;
        }
      }

      await sendPrintCommandToLocalAgent(
        printerId,
        payload,
        serverSidePrinting
      );

      if (enableReprint) {
        let save = {};
        save.data = payload;
        save.printer = printerId;
        save.mode = "CLOUD_PRINT";
        localStorage.setItem("w_lastPrint", JSON.stringify(save));
      }
      if (confirmPrint) {
        setAlert({
          show: true,
          title: translate("Success"),
          message: translate("Print Successful"),
          type: "success",
        });
      }
      break;
    } catch (err) {
      console.log("Error while printing Will Retry", err);
      if (i >= 2) {
        if (setAlert) {
          setAlert({
            show: true,
            title: translate("Error!"),
            message: translate(
              'Error While printing, Check agent is running and "Receipt" printer connected'
            ),
          });
        }
      }
    }
  }
}

async function sendPrintRequestToPosServer(payload) {
  let response = await API.post("/api/v1/agent/printjasper", payload);
  console.log(response);
  return response;
}

async function sendPrintRequestToServer(url, token, payload, printerId) {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let respose = await axios.post(
    "/cloudprintbackend/api/v1/core/device/" + printerId + "/print",
    payload,
    config
  );
  return respose;
}
const curTzMap = {
  AED: "Asia/Dubai",
  SAR: "Asia/Riyadh",
  BHD: "Asia/Bahrain",
  OMR: "Asia/Muscat",
};

async function preparePayload(
  configKey,
  printData,
  printerId,
  withOpenDrawer,
  terminalBean,
  buttonIndex
) {
  console.log("buttonIndex preparePayload", buttonIndex);
  let configText = {};
  let storeBean = {};
  if (configKey.template) {
    configText = JSON.stringify(configKey);
  } else {
    let dbData = await db.config.where("name").equals(configKey).toArray();
    configText = dbData[0].configTxt;

    dbData = await db.setting.where("sKey").equals("store").toArray();
    storeBean = JSON.parse(dbData[0].sValue);
    storeBean["storeName"] = localStorage.getItem("storeName");
    storeBean["timeZone"] = curTzMap[storeBean.currency];
    dbData = await db.setting.where("sKey").equals("email").toArray();
    if (dbData.length > 0) {
      let email = JSON.parse(dbData[0].sValue);
      storeBean["address1"] = email.address1;
      storeBean["address2"] = email.address2;
      storeBean["trn"] = email.trn;
    }
  }
  let token = localStorage.getItem("w_accessToken");
  let jwt = Store.parseJwt(token);
  printData["user"] = { userName: jwt.sub };
  printData["meta"] = storeBean;

  if (terminalBean) {
    printData["terminalBean"] = terminalBean;
  }

  let baseUrl = "";
  if (AgentUtils.isAndroid()) {
    baseUrl = window.JSBridge.getBaseURL();
  } else {
    baseUrl = window.location.origin;
  }
  let payload = {};

  if (configText.startsWith("{")) {
    let configJson = JSON.parse(configText);
    payload["template"] = configJson.template;
    printData["config"] = configJson.config;
    payload["data"] = printData;
  } else {
    let buffer = EscPos.getBufferFromTemplate(configText, printData);
    var base64String = Buffer.from(String.fromCharCode(...buffer)).toString(
      "base64"
    );
    payload["data"] = base64String;
  }
  payload["server"] = baseUrl;
  payload["token"] = localStorage.getItem("w_refreshToken");
  payload["printerId"] = printerId;

  if (terminalBean && terminalBean.receiptPrinterPageSize) {
    payload["pageSize"] = terminalBean.receiptPrinterPageSize;
  }

  if (withOpenDrawer) {
    payload["openDrawer"] = true;
  }
  return payload;
}

async function getCloudPrintToken() {
  let sValue = await db.setting
    .where("sKey")
    .equals("store_cloud_print")
    .toArray();

  let cloudpRingConfig = JSON.parse(sValue[0].svalue);
  let url = cloudpRingConfig.cloudPrinterUrl;
  let apiKey = cloudpRingConfig.cloudPrinterApiKey;

  let { data } = await axios.post(
    "/cloudprintbackend/api/v1/auth/signin_with_apikey",
    {
      securityKey: apiKey,
    }
  );
  return [url, data.accessToken];
}

async function openDrawer(terminalBean, setAlert, translate) {
  if (terminalBean.printingMode === "CLOUD_PRINT") {
    let url = "";
    let apiKey = "";
    let token = "";
    for (let i = 0; i < 3; i++) {
      try {
        if (localStorage.getItem("w_cloud_print_token")) {
          token = localStorage.getItem("w_cloud_print_token");
          url = localStorage.getItem("w_cloud_print_url");
        } else {
          [url, token] = await getCloudPrintToken();
          localStorage.setItem("w_cloud_print_token", token);
        }

        try {
          await sendOpenDrawerCommandToServer(
            url,
            token,
            terminalBean.receiptPrinter
          );
        } catch (e) {
          //if Expired
          [url, token] = await getCloudPrintToken(url, apiKey);
          localStorage.setItem("w_cloud_print_token", token);
          await sendOpenDrawerCommandToServer(
            url,
            token,
            terminalBean.receiptPrinter
          );
        }
      } catch (err) {
        console.log("Error while openeing drawer Will Retry", err);
        if (i >= 2) {
          if (setAlert) {
            setAlert({
              show: true,
              title: translate("Failed"),
              message: translate("Open Drawer Command Failed"),
              type: "failure",
            });
          }
        }
      }
    }
  } else if (terminalBean.printingMode === "BLUETOOTH") {
    setAlert({
      show: true,
      title: translate("Not Supported"),
      message: translate("Open Drawer command is not supported over Bluetooth"),
      type: "failure",
    });
  } else if (terminalBean.printingMode === "LOCAL") {
    await sendOpenDrawerCommandToLocalAgent(terminalBean.receiptPrinter);
  }
}
async function sendOpenDrawerCommandToLocalAgent(printerid) {
  try {
    let respose = await axios.post(
      "http://localhost:3337/agent/device/opendrawer",
      { printerId: printerid }
    );
    return respose;
  } catch (err) {
    console.log("printutils error", err);
  }
}

async function sendOpenDrawerCommandToServer(url, token, printerId) {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  let respose = await axios.post(
    "/cloudprintbackend/api/v1/core/device/" + printerId + "/opendrawer",
    config
  );
  return respose;
}

async function rePrint(
  terminalBean,
  setAlert,
  translate,
  confirmPrint,
  pdfVewer
) {
  let lastPrint = localStorage.getItem("w_lastPrint");

  if (lastPrint) {
    let d = JSON.parse(lastPrint);

    if (terminalBean.printingMode === "CLOUD_PRINT") {
      let url = "";
      let apiKey = "";
      let token = "";

      for (let i = 0; i < 3; i++) {
        try {
          if (localStorage.getItem("w_cloud_print_token")) {
            token = localStorage.getItem("w_cloud_print_token");
            url = localStorage.getItem("w_cloud_print_url");
          } else {
            [url, token] = await getCloudPrintToken();
            localStorage.setItem("w_cloud_print_token", token);
          }

          try {
            await sendPrintRequestToServer(url, token, d.payload, d.printerId);
          } catch (e) {
            //if Expired
            [url, token] = await getCloudPrintToken(url, apiKey);
            localStorage.setItem("w_cloud_print_token", token);
            await sendPrintRequestToServer(url, token, d.payload, d.printerId);
          }
        } catch (err) {
          console.log("Error while openeing drawer Will Retry", err);
          if (i >= 2) {
            if (setAlert) {
              setAlert({
                show: true,
                title: translate("Failed"),
                message: translate("Open Drawer Command Failed"),
                type: "failure",
              });
            }
          }
        }
      }
    } else if (terminalBean.printingMode === "BLUETOOTH") {
      if (AgentUtils.isAndroid()) {
        let response = window.JSBridge.print("BT", d.data);
        if (response === "OK") {
          console.log("OK response");
          if (confirmPrint) {
            setAlert({
              show: true,
              title: translate("Success"),
              message: translate("Print Successful"),
              type: "success",
            });
          }
        } else {
          if (setAlert) {
            setAlert({
              show: true,
              title: translate("Error!"),
              message: translate(
                "Error While Printing, check Bluetooth Printer is connected"
              ),
            });
          }
        }
      } else {
        setAlert({
          show: true,
          title: translate("Error!"),
          message: translate(
            "Can not use Bluetooth Printer Here , Please use Android App or Cloud Printer"
          ),
        });
      }
    } else if (terminalBean.printingMode === "LOCAL") {
      await sendPrintCommandToLocalAgent(terminalBean.receiptPrinter, d.data);
    } else {
      let response = await sendPrintRequestToPosServer(d.data);
      pdfVewer(response);
    }
  }
}

async function sendPrintCommandToLocalAgent(
  printerId,
  payload,
  serverSidePrinting
) {
  payload["printerId"] = printerId;
  if (serverSidePrinting) {
    let api =
      (await AgentUtils.getBaseUrl()) + "/api/v1/agent/generateandprint";
    let response = await API.post(api, payload);
    return response;
  } else {
    let response = await axios.post(
      "http://localhost:3337/agent/device/print",
      payload
    );
    return response;
  }
}
